import { makeStyles, Typography } from '@material-ui/core';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { useRecoilState, useSetRecoilState } from 'recoil';
import { openChatState, PROVIDER_CHAT, SUPPORT_CHAT } from 'pages/CustomerBooking';
import ReactJson from 'react-json-view';
import { useCallback, useEffect, useMemo, useState } from 'react';
import useCustomModal from 'components/CustomConfirm';
import CustomConfirmDialog from 'components/CustomConfirm/CustomConfirmDialog';
import { cancelBooking } from 'services/booking.service';
import { useHistory } from 'react-router-dom';
import { useTrackEvent } from 'util/trackEvent';
import { isWaitingForPollState } from '../RecoilState';

const useStyles = makeStyles((theme) => {
  return {
    header: {
      paddingTop: theme.spacing(5),
      [theme.breakpoints.down("sm")]: {
        paddingTop: theme.spacing(2),
      },
      textAlign: 'center',
      overflowWrap: 'anywhere',
    },
    content: {
      textAlign: 'center',
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      justifyContent: 'center',
      "&>*": {
        width: '80%',
        marginBottom: theme.spacing(2)
      },
      paddingBottom: theme.spacing(5),
      [theme.breakpoints.down("sm")]: {
        paddingBottom: theme.spacing(2),
      },
    }
  }
})

const InvalidLocationConfirm = ({
  open,
  onClose,
  onCancel,
  onConfirm,
  title = "Are you sure?",
  description = "",
  confirmationText = "Ok",
  cancellationText = "Cancel",
  noCancel = false,
  error,
  onOpenSupport = () => { },
  onSelectEdit = () => { },
  booking,
  trackEvent = (evt, props, retain) => {},
  confirm,
  updatedLocation,
  locationId
}) => {
  const classes = useStyles()
  const setChatOpen = useSetRecoilState(openChatState);
  const history = useHistory()
  const [isWaitingForPoll, setIsWaitingForPoll] = useRecoilState(isWaitingForPollState);
  
  const errorMessage = useMemo(
    () => {
      return error?.message?.en ?? error?.message ?? error?.details
    }, [error]
  );

  const locationProps = useMemo(
    () => {
      const prop = {
        error: error?.code,
        locationId,
        latitude: updatedLocation?.latitude,
        longitude: updatedLocation?.longitude,
      }
      return prop
    }, [error, updatedLocation, locationId]
  );

  
  const doShowCancellation = useCallback(
    () => {
      if (booking?.is_whitelabel) {
        confirm(props => (
          <CustomConfirmDialog {...props}
            description={
              <Typography>To book again, contact {booking?.white_label?.partner?.label} or download the app for more services.</Typography>
            }
            title='Your booking is now cancelled'
            confirmationText='Download App'
            onConfirm={() => {
              trackEvent('Location Confirm Error - Booking cancelled - Download App ', { dialog: ['InvalidLocationConfirm', 'doShowCancellation'], ...locationProps }, { retainProps: true })
              props.onClose()
            }}
            noCancel
          />
        ))
      }
      else {
        confirm(props => (
          <CustomConfirmDialog {...props}
            description={
              <Typography>To create new appointment, click below</Typography>
            }
            title='Your booking is now cancelled'
            confirmationText='Create new Appointment'
            onConfirm={() => {
              props.onClose()
              trackEvent('Location Confirm Error - Booking cancelled - Book again', { dialog: ['InvalidLocationConfirm', 'doShowCancellation'], ...locationProps }, { retainProps: true })
              history.push(`/createbooking/servicepackages`)
              window.location.reload()
            }}
            noCancel
          />
        ))
      }
    },
    [confirm, booking],
  );
  
  const doCancelBooking = useCallback(
    async () => {
      confirm(props => (
        <CustomConfirmDialog {...props}
          description={<Typography>Are you sure you want to cancel this booking?</Typography>}
          title='Are you sure you want to cancel your booking?'
          confirmationText='Yes, Cancel'
          cancellationText='Changed my mind'
          onConfirm={async () => {
            setIsWaitingForPoll(true)
            trackEvent('Location Confirm Error - Cancel Booking - Yes', { dialog: ['InvalidLocationConfirm', 'doCancelBooking'], ...locationProps }, {retainProps: true})
            props.onClose()
            await cancelBooking(booking?.id)
            onClose()
            doShowCancellation()
          }}
          onCancel={async () => {
            trackEvent('Location Confirm Error - Cancel Booking - Changed my mind', { dialog: ['InvalidLocationConfirm', 'doCancelBooking'], ...locationProps }, {retainProps: true})
            props.onClose()
          }}
        />
      ))
    },
    [booking?.id, confirm, doShowCancellation],
  );

  

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      disableEnforceFocus
    >
      <DialogTitle className={classes.header}><Typography variant="h2">
        {errorMessage}
      </Typography></DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={() => {
            trackEvent('Location Confirm Error - Edit location - click', { dialog: ['InvalidLocationConfirm'], ...locationProps }, {retainProps: true})
            onClose()
          }}
        >
          Edit location
        </Button>
        <Button
          fullWidth
          color="primary"
          variant="outlined"
          onClick={() => {
            trackEvent('Location Confirm Error - Cancel Booking - click', { dialog: ['InvalidLocationConfirm'], ...locationProps }, {retainProps: true})
            doCancelBooking()
          }}
        >
          Cancel booking
        </Button>
        <Button
          fullWidth
          color="primary"
          variant="text"
          size="small"
          onClick={() => {
            trackEvent('Location Confirm Error -  Contact us - click', { dialog: ['InvalidLocationConfirm'], ...locationProps }, {retainProps: true})
            onOpenSupport()
            onClose()
          }}
        >
          Contact us
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { InvalidLocationConfirm }



